import { render, staticRenderFns } from "./OffersListDetails.vue?vue&type=template&id=64662c1e"
import script from "./OffersListDetails.vue?vue&type=script&lang=js"
export * from "./OffersListDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports